/* eslint-disable no-nested-ternary */
import { trackGTMEvent, trackGTMEventV2, trackTjkGTM, updateGTMDimensions } from './googleTagManager';
import { format } from 'date-fns';
import { logError } from 'Utils/errorHandler';
import { dateToJavaTimeConverterGTM } from 'Utils/dateConverters';
import ProjectConfig from 'ProjectConfig';
import { EVENT_FIELD_MAPPING, GTA_SPORT_TYPE_NAMING, SPORT_TYPE_UPPER_CASE } from 'Store/constants/sportTypes';
import { RUNWAY_TYPES } from 'Utils/horseRacesNameMapper';
import { pick } from 'lodash';

const matchTypeKeys = {
  SOCCER: 'futbol',
  TENNIS: 'tenis',
  VOLLEYBALL: 'voleybol',
  BASKETBALL: 'basketbol'
};

const matchTypeTurkishKeys = {
  futbol: 'Futbol',
  basketbol: 'Basketbol',
  tenis: 'Tenis'
};

//TODO: Move analytics to here
export const GA_TRACKING_ID = ProjectConfig.GA_CODE;
export const MARKETING_TRACKING_ID = ProjectConfig.MARKETING_GA_CODE;
const gtag = typeof window !== 'undefined' ? window.gtag : () => { };

export const trackPageView = (title, url) => {
  //TODO: Check if we should use a common pattern on top of components
  const sanitize = ['Bilyoner | ', 'Bilyoner.com | ', ' | Bilyoner', 'Bilyoner.com - '];
  sanitize.forEach((keyword => {
    if (title.indexOf(keyword) >= 0) {
      title = title.replace(keyword, '');
    }
  }));
  //TODO: Check if we should use url or component class for screen views
  trackEvent('page_view', { page_title: title, page_location: url });
};

const oddToItem = (oddParams, tracker) => {
  let oddObject = {
    price: oddParams?.oddValue,
    value: oddParams?.oddValue,
    mbs: oddParams?.mbs
  };

  try {
    if (tracker === 'firebase') {
      oddObject = {
        ...oddObject,
        currency: 'TRY',
        quantity: 1,
        item_id: oddParams?.eventId?.toString(),
        item_name: oddParams?.eventName,
        item_brand: oddParams?.sportType,
        item_category: oddParams?.eventLeague,
        item_variant: oddParams?.marketName
      };

      if (oddParams?.eventStartDate) {
        oddObject = {
          ...oddObject,
          eventDate: format(new Date(oddParams?.eventStartDate), 'dd.MM.yyyy HH:mm'),
        };
      }
    } else {
      const variant = oddParams.variant === 0 ? undefined : `${oddParams?.marketName}--${oddParams?.betType}`;

      oddObject = {
        ...oddObject,
        id: oddParams?.eventId?.toString(),
        quantity: '1',
        name: oddParams?.eventName,
        brand: oddParams?.sportType,
        category: oddParams?.eventLeague,
        variant: variant,
        dimension9: oddParams?.startTime,
        dimension10: oddParams?.isBanker ? 'YES' : 'NO',
        dimension11: oddParams?.isLive ? 'YES' : 'NO',
        dimension12: oddParams?.mbs?.toString(),
      };

      if (oddParams.variant) {
        oddObject = {
          ...oddObject,
          variant: oddParams.variant
        };
      }


      if (oddParams?.eventStartDate) {
        oddObject = {
          ...oddObject,
          dimension8: dateToJavaTimeConverterGTM(oddParams?.eventStartDate),
        };
      }
    }
  } catch (err) {
    logError(err);
  }

  return oddObject;
};

export const trackBetSlipViewed = ({ coupon, analyticOdds = [], validatedCoupon }) => {

  const baseConfig = {
    currency: 'TRY',
    value: coupon?.couponCost,
    total_ratio: validatedCoupon?.totalOdd,
    multiplier: coupon?.multiplier,
    system: coupon?.system?.join(','),
    max_profit: validatedCoupon?.expectedWinAmount,
    coupon: coupon?.sourceCouponId,
    affiliation: coupon?.source,
    multiple_coupon_count: coupon?.couponCount
  };


  trackGTMEvent('bet_slip_viewed', {
    ...baseConfig,
    items: analyticOdds.map(odd => oddToItem(odd, 'gtm'))
  });
};

export const trackBeginCheckout = ({ coupon, analyticOdds = [] }) => {
  const baseConfig = {
    currency: 'TRY',
    value: coupon?.couponCost,
    total_ratio: coupon?.totalOdd,
    multiplier: coupon?.multiplier,
    system: coupon?.system?.join(','),
    max_profit: coupon?.expectedWinAmount,
    affiliation: coupon?.source,
    multiple_coupon_count: coupon?.couponCount
  };

  trackGTMEvent('begin_checkout', {
    ...baseConfig,
    coupon: coupon?.sourceCouponId,
    items: analyticOdds.map(odd => oddToItem(odd, 'gtm'))
  });

  trackEvent('begin_checkout', {
    ...baseConfig,
    items: analyticOdds.map(odd => oddToItem(odd, 'firebase'))
  });
};

export const trackBeginCheckoutEP = ({ items, price, quantity }) => {
  trackGTMEvent('checkout_view', {
    items: items,
    price: price,
    quantity: quantity
  });
};


export const trackPurchase = ({ coupon, analyticOdds = [] }) => {
  const baseConfig = {
    currency: 'TRY',
    value: coupon?.couponCost,
    total_ratio: coupon?.totalOdd,
    multiplier: coupon?.multiplier,
    system: coupon?.system?.join(','),
    max_profit: coupon?.expectedWinAmount,
    coupon: coupon?.sourceCouponId,
    affiliation: coupon?.source,
    multiple_coupon_count: coupon?.couponCount,
    transaction_id: coupon?.transactionId
  };

  trackEvent('purchase', {
    ...baseConfig,
    items: analyticOdds.map(odd => oddToItem(odd, 'firebase'))
  });

  trackGTMEvent('purchase', {
    ...baseConfig,
    items: analyticOdds.map(odd => oddToItem(odd, 'gtm'))
  });
};

export const trackSporToto = coupon => {
  trackGTMEvent('purchase_sport_toto', {
    actionField: {
      id: coupon.id,
      affiliation: 'SporTOTO',
      revenue: coupon.revenue,
    },
    products: [coupon.products.map((item, index) => {
      return {
        name: item.id,  // Name or ID is required.
        id: 'sportoto',  //Sportoto kuponu için daha önce bir ürün ID belirlendi ise ürün ID yazılmalı, eğer belirlenmei ise "sportoto" yazılmalı.
        price: coupon.totalAmount, // Kupon Oynama bedeli
        brand: 'Spor Toto',
        category: 'Spor Toto',
        quantity: 1,
      };
    })]
  });
};

export const trackPurchaseRefund = (couponId, amount) => {
  trackEvent('purchase_refund', {
    transaction_id: couponId,
    value: amount
  });
};

export const trackOddAdded = (oddParams, options = { list: null, position: null }, tabName, tabType) => {
  trackEvent('add_to_cart', { ...oddToItem(oddParams, 'firebase'), list: options.list, position: options.position });
  trackGTMEvent('add_to_cart', { items: [oddToItem(oddParams, 'gtm')], list: options.list, position: options.position }, tabName, tabType);
};

export const trackOddRemoved = (oddParams, options = { list: null, position: null }, tabName) => {
  trackEvent('remove_from_cart', { ...oddToItem(oddParams, 'firebase'), list: options.list, position: options.position });
  trackGTMEvent('remove_from_cart', { items: [oddToItem(oddParams, 'gtm')], list: options.list, position: options.position }, tabName);
};

export const trackRegistration = () => {
  trackEvent('sign_up', { user_id: 'form' }, true);
  trackGTMEvent('register');
};

export const trackCommentTribunCoupon = feedId => {
  trackEvent('tribun_comment_made', {
    Category: 'Tribün Kupon',
    couponId: feedId
  }, true);
};

export const trackLikeTribunCoupon = feedId => {
  trackEvent('tribun_coupon_like', {
    Category: 'Tribün Kupon',
    couponId: feedId
  }, true);
};

export const trackShowTribunCoupon = feedId => {
  trackEvent('tribun_product_view', {
    Category: 'Tribün Kupon',
    couponId: feedId
  }, true);
};

export const trackFollowTribunUser = () => {
  trackEvent('tribun_follow_tipster', {
    Category: 'Tribün Takip'
  }, true);
};

export const trackReportTribunCoupon = complaintItemId => {
  trackEvent('tribun_report_coupon', {
    Category: 'Tribün Kupon',
    couponId: complaintItemId
  }, true);
};

export const trackDeleteTribunComment = (feedId, commentId, commentAuthorId) => {
  trackEvent('tribun_comment_deleted', {
    Category: 'Tribün Kupon',
    commentId: commentId,
    couponId: feedId,
    commentAuthorId: commentAuthorId
  }, true);
};

export const trackLeaderBoard = () => {
  trackEvent('tribun_leaderboard', {
    Category: 'Tribun Leaderboard'
  }, true);
};

export const trackPromotionView = (promotion, options = { list: null, position: null }) => {
  trackGTMEvent('promotion_impression', { ...promotion, list: options.list, position: options.position });
};

export const trackCampaignPromotionView = promotion => {
  trackGTMEvent('promotion_impression_campaign', { ...promotion });
};

export const trackPromotionClick = (promotion, options = { list: null, position: null }) => {
  trackGTMEvent('promotion_click', { ...promotion, list: options.list, position: options.position });
};

export const trackProductView = oddParams => {
  trackGTMEvent('product_detail_view', { items: [oddToItem(oddParams, 'gtm')] });
};

export const trackProductClick = (oddParams, { tabName, tabType }) => {
  trackGTMEvent('product_detail_click', { items: [oddToItem(oddParams, 'gtm')] }, tabName, tabType);
};

export const trackProductClickLiveStream = (oddParams, { tabName, tabType }) => {
  trackGTMEvent('product_detail_click', { items: [oddParams] }, tabName, tabType);
};

export const trackProductClickChangeGames = (oddParams, { tabName, tabType }) => {
  trackGTMEvent('product_detail_click', { items: [oddParams] }, tabName, tabType);
};

export const trackImpressionView = (list, { tabName, tabType }) => {
  tabName = tabName ? tabName : 'iddaa';
  trackGTMEvent('product_impression', list, tabName, tabType);
};

export const trackImpressionViewForLiveStream = (list, { tabName, tabType }) => {
  trackGTMEvent('product_impression_for_live_stream', list, tabName, tabType);
};

export const trackTjkProgram = (horses, obj) => {
  let trackTjkObj = horses?.map((item, index) => {
    return {
      item_id: 'TJK10001', // Seçim kodu
      item_name: item.horseName, // Atın Adı
      item_brand: 'TJK', // TJK basılmalıdır.
      item_category: `${obj.hippodrome} - ${obj.ganyan} `, // {Hipodrom} - {Ganyan Türü}
      item_category2: obj.hippodrome,  // Hipodrom Adı
      item_category3: obj.ganyan, // Ganyan Türü
      item_category4: RUNWAY_TYPES[obj.runwayType], // Pist Tipi, Ex: Çim veya Kum
      item_variant: item.jockeyName, // Jokey adı
      item_list_id: 'tjk_at_yarisi', // Ganyanın görüntülendiği liste id’si
      item_list_name: 'TJK - At Yarışı', // Ganyanın görüntülendiği liste adı
      quantity: 1,
      price: 1.00 // Zorunlu parametre olmasından dolayı 1.00 olarak basılmalı
    };
  });
  trackTjkGTM(trackTjkObj, 'view_item_list');
};

export const trackTjkAddToCart = obj => {
  let trackTjkObj = {
    item_id: 'TJK10001',
    item_name: obj?.horseName,
    item_brand: 'TJK',
    item_category: `${obj?.hippodrome} - ${obj?.ganyan} `,
    item_category2: obj?.hippodrome,
    item_category3: obj?.ganyan,
    item_category4: RUNWAY_TYPES[obj?.runwayType],
    item_variant: obj?.jockeyName,
    item_list_id: 'tjk_at_yarisi',
    item_list_name: `TJK - At Yarışı - ${obj.type}`,
    quantity: 1,
    price: 1.00
  };
  trackTjkGTM(trackTjkObj, 'add_to_cart');
};

export const trackTjkSelectItem = obj => {
  let trackTjkObj = {
    item_id: 'TJK10001',
    item_name: obj?.horseName,
    item_brand: 'TJK',
    item_category: `${obj?.hippodrome} - ${obj?.ganyan} `,
    item_category2: obj?.hippodrome,
    item_category3: obj?.ganyan,
    item_category4: RUNWAY_TYPES[obj?.runwayType],
    item_variant: obj?.jockeyName,
    item_list_id: 'tjk_at_yarisi',
    item_list_name: `TJK - At Yarışı - ${obj.type}`,
    quantity: 1,
    price: 1.00
  };
  trackTjkGTM(trackTjkObj, 'select_item');
};

export const trackTjkViewItem = obj => {
  let trackTjkObj = {
    item_id: 'TJK10001',
    item_name: obj?.horseName,
    item_brand: 'TJK',
    item_category: `${obj?.hippodrome} - ${obj?.ganyan} `,
    item_category2: obj?.hippodrome,
    item_category3: obj?.ganyan,
    item_category4: RUNWAY_TYPES[obj?.runwayType],
    item_variant: obj?.jockeyName,
    item_list_id: 'tjk_at_yarisi',
    item_list_name: obj.type ? `TJK - At Yarışı - ${obj?.type}` : 'TJK - At Yarışı',
    quantity: 1,
    price: 1.00
  };
  trackTjkGTM(trackTjkObj, 'view_item');
};

export const trackTjkViewCart = (horses, obj) => {
  let trackTjkObj = horses?.map((item, index) => {
    return {
      item_id: 'TJK10001',
      item_name: item.horseName,
      item_brand: 'TJK',
      item_category: `${obj.hippodrome} - ${obj.ganyan} `,
      item_category2: obj.hippodrome,
      item_category3: obj.ganyan,
      item_category4: RUNWAY_TYPES[obj.runwayType],
      item_variant: item.jockeyName,
      item_list_id: 'tjk_at_yarisi',
      item_list_name: 'TJK - At Yarışı',
      quantity: 1,
      price: 1.00 // Zorunlu parametre olmasından dolayı 1.00 olarak basılmalı
    };
  });
  trackTjkGTM({ trackTjkObj, cost: obj.cost }, 'view_cart');
};

export const trackTjkPLay = (horses = [], obj = {}) => {
  const runwayTypes = Array.isArray(obj.runwayType)
    ? obj.runwayType
    : [];

  let trackTjkObj = horses.map(item => ({
    item_id: 'TJK10001',
    item_name: item.horseName,
    item_brand: 'TJK',
    item_category: `${obj.hippodrome} - ${obj.ganyan}`,
    item_category2: obj.hippodrome,
    item_category3: obj.ganyan,
    item_category4: runwayTypes.map(
      runway => RUNWAY_TYPES[runway.RunwayTypeEnum]
    ),
    item_variant: item.jockeyName,
    item_list_id: 'tjk_at_yarisi',
    item_list_name: 'TJK - At Yarışı',
    quantity: 1,
    price: 1.00
  }));

  trackTjkGTM({ trackTjkObj, cost: obj.cost }, 'begin_checkout');
  trackTjkGTM({ trackTjkObj, cost: obj.cost }, 'purchase');
};

export const trackLiveStreamTotalSeconds = totalSeconds => {
  trackEvent('live_stream', { value: totalSeconds });
};

export const trackEvent = (eventName, eventArgs, trackForGtm) => {
  if (typeof gtag === 'function') {
    const eventArgsWithVersion = {
      ...eventArgs,
      version: ProjectConfig.version,
      channel: 'web'
    };

    gtag('event', eventName, eventArgsWithVersion);

    if (trackForGtm) {
      trackGTMEvent(eventName, eventArgsWithVersion);
    }
  }
};

export const setUserAttribute = (key, value) => {
  if (typeof gtag === 'function') {
    gtag('config', GA_TRACKING_ID, {
      [key]: value
    });
    updateGTMDimensions({
      [key]: value
    }, {});
  }
};

export const trackCampaignJoin = () => {
  trackGTMEvent('joined_campaign');
};

export const trackCampaignDetails = (utm_source, utm_medium, utm_campaign ) => {
  trackGTMEventV2({ utm_source, utm_medium, utm_campaign }, 'campaign_details');
};

export const trackThrowBackCouponView = () => {
  trackGTMEvent('view_tarihte_bugun');
};

export const trackRaffleBuyTicket = eventArg => {
  trackGTMEvent('purchase_ep', eventArg);
};


export const trackScratchBuyTicket = eventArg => {
  trackGTMEvent('purchase_sans_oyunlari', eventArg);
};

export const trackSwitchProductClick = () => {
  trackEvent('Diğer maça git', {
    Category: 'Maç Kartı',
    screenName: 'Maç Kartı/Diğer',
  });
};

export const trackMatchCard = ({ name, id, brand, category }) => {
  trackGTMEvent('view_mac_karti', {
    item_name: name,
    item_id: id,
    item_brand: brand,
    item_category: category
  });
};

export const trackViewItemList = (list, { tabName, tabType }) => {
  const items = [];
  list?.list.forEach((list, i) => {
    const listObject = {
      item_id: list.id.toString().toLowerCase(),
      item_name: list[EVENT_FIELD_MAPPING.eventName]?.toLowerCase(),
      item_brand: GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]].toLowerCase(),
      item_category: list[EVENT_FIELD_MAPPING.leagueName].toLowerCase(),
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_variant: null,
      price: null,
      quantity: 1,
      index: i,
      mbs: null,
      match_time: null,
      bet_type: null,
      item_list_name: 'home page - popüler',
      item_list_id: 'home page - popüler',
    };
    items.push(listObject);
  });

  trackGTMEvent('view_item_list', {
    event: 'view_item_list',
    ecommerce: {
      item_list_id: 'home page - popüler',
      item_list_name: 'home page - popüler',
      items
    },

  });
};

export const trackViewLiveScoreList = (list, { tabName, tabType }) => {
  const getEventType = eventKey => {
    switch (eventKey) {
      case 'kuponumdakiler':
        return 'kuponumdakiler';
      case 'basketbol-canli-skor':
        return 'basketbol';
      default:
        return 'futbol';
    }
  };

  const location = window.location.pathname.split('/');
  const eventType = getEventType(location[2]);
  const itemListName = `Canlı Sonuçlar - ${eventType}`;

  const items = [];
  list?.list.forEach((list, index) => {
    const listObject = {
      item_id: list.id.toString().toLowerCase(),
      item_name: `${list.homeTeam} - ${list.awayTeam}`.toLowerCase(),
      item_brand: 'iddaa',
      item_category: null,
      item_list_name: 'canlı sonuçlar',
      item_list_id: 'canlı sonuçlar',
      index: index,
      item_category2: null,
      item_category3: null,
      item_category4: null, //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
      item_variant: GTA_SPORT_TYPE_NAMING[list.sportType].toLowerCase(),
      quantity: 1,
      mbs: null,
      match_time: null, // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    };
    items.push(listObject);
  });


  trackGTMEventV2({ items, itemListName }, 'view_item_list', 'liveScores');
};


export const trackSelectItemLiveScores = (obj, balance) => {
  const getEventType = eventKey => {
    switch (eventKey) {
      case 'kuponumdakiler':
        return 'kuponumdakiler';
      case 'basketbol-canli-skor':
        return 'basketbol';
      default:
        return 'futbol';
    }
  };

  const location = window.location.pathname.split('/');
  const eventType = getEventType(location[2]);

  const itemListName = `Canlı Sonuçlar - ${eventType}`;

  let trackObj = {
    item_id: obj.eventId,
    item_name: `${obj.homeTeam} - ${obj.awayTeam}`,
    item_brand: 'iddaa',
    item_category: null,
    item_list_name: itemListName,
    item_list_id: itemListName,
    item_category2: null,
    item_category3: null,
    item_category4: null, //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
    quantity: 1,
    match_time: null, // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
  };


  trackGTMEventV2({ items: [trackObj], balance, itemListName }, 'select_item', 'liveScores');
  trackGTMEventV2({ items: [trackObj], balance, itemListName }, 'view_item', 'liveScores');
};

export const trackViewChanceGamesList = ({ gameList, balance }) => {
  const pickedGameDataList = gameList.map(game => {
    const pickedValues = pick(game, ['id', 'name']);

    return {
      ...pickedValues,
      item_brand: 'Şans Oyunları',
      item_list_id: 'şans_oyunları',
      item_list_name: 'Şans Oyunları',
      quantity: 1
    };
  });

  trackGTMEventV2({ items: pickedGameDataList, balance }, 'view_item_list', 'chanceGames');
};

export const trackSelectChanceGame = ({ game, balance }) => {

  const gameData = {
    ...(pick(game, ['id', 'name'])),
    item_brand: 'Şans Oyunları',
    item_list_id: 'şans_oyunları',
    item_list_name: 'Şans Oyunları',
    quantity: 1
  };

  trackGTMEventV2({ items: [gameData], balance }, 'select_item', 'chanceGames');
  trackGTMEventV2({ items: [gameData], balance }, 'view_item', 'chanceGames');
};

export const trackViewHomePageBannerList = matchList => {
  const pickedBannerMatchList = matchList.map(game => {
    const pickedValues = pick(game, ['eventId', 'name']);

    return {
      id: pickedValues.eventId,
      name: pickedValues.name,
      item_brand: 'iddaa',
      item_list_id: 'Home Page - Banner',
      item_list_name: 'Home Page - Banner',
      item_category: null,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_variant: null,
      quantity: 1,
      match_time: null,
    };
  });

  trackGTMEventV2({ items: pickedBannerMatchList, }, 'view_item_list', 'homePageBanner');
};

export const trackSelectBannerMatchItem = match => {
  const { eventId, name } = match;
  const matchData = {
    id: eventId,
    name,
    item_brand: 'iddaa',
    item_list_id: 'Home Page - Banner',
    item_list_name: 'Home Page - Banner',
    item_category: null,
    item_category2: null,
    item_category3: null,
    item_category4: null,
    item_variant: null,
    quantity: 1,
    match_time: null,
  };

  trackGTMEventV2({ items: [matchData] }, 'select_item', 'homePageBanner');
  trackGTMEventV2({ items: [matchData] }, 'view_item', 'homePageBanner');
};

export const trackViewItemListNextLiveMatches = (list, obj) => {
  const location = window.location.href.split('/');
  const path = window.location.pathname.split('/').filter(item => item !== '');
  const isHomePage = path.length === 0;
  const isCategoryAll = location.length === 4 && location[location.length - 1] === 'canli-iddaa';
  const category = isCategoryAll ? 'Tümü' : SPORT_TYPE_UPPER_CASE[obj?.tabType];
  const item_list_name = isHomePage ? 'Home Page - Canlı' : location[3] === 'iddaa' ? `${category}` : `Canlı - ${category}`;
  const items = [];
  list?.list.forEach((item, index) => {
    const listObject = {
      item_id: item.id.toString(),
      item_name: item[EVENT_FIELD_MAPPING.eventName],
      item_brand: 'iddaa',
      item_category: item[EVENT_FIELD_MAPPING.leagueName],
      item_list_name: item_list_name,
      item_list_id: item_list_name,
      index: index,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_variant: GTA_SPORT_TYPE_NAMING[item[EVENT_FIELD_MAPPING.sportType]],
      quantity: 1,
      mbs: item.mbs,
      match_time: null, // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    };
    items.push(listObject);
  });

  if (location === 'iddaa') {
    trackGTMEventV2({ items, category: item_list_name }, 'view_item_list', 'bulletin');
  } else {
    trackGTMEventV2({ items, category: item_list_name }, 'view_item_list', 'next-live-matches');
  }
};

export const trackSelectItemNextLiveMatches = (data, balance) => {
  const items = [];
  const location = window.location.href.split('/');
  const path = window.location.pathname.split('/').filter(item => item !== '');
  const isHomePage = location.length === 3;
  const category = isHomePage ? 'Home Page - Canlı' : SPORT_TYPE_UPPER_CASE[path.length < 2 ? 'futbol' : path[1]];
  const list_name = location[3] === 'canli-iddaa' ? `Canlı - ${category}` : category;


  const trackObj = {
    item_id: data.id.toString(),
    item_name: data[EVENT_FIELD_MAPPING.eventName],
    item_brand: 'iddaa',
    item_category: data[EVENT_FIELD_MAPPING.leagueName],
    item_list_name: list_name,
    item_list_id: list_name,
    item_category2: data.htn,
    item_category3: null, //burada item.lgn ile lig adı alınabiliyor ancak istenilen data sağlanamıyor
    item_category4: null, //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
    item_variant: GTA_SPORT_TYPE_NAMING[data[EVENT_FIELD_MAPPING.sportType]],
    quantity: 1,
    mbs: data.mbs,
    match_time: null, // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
  };

  items.push(trackObj);

  if (location === 'iddaa') {
    trackGTMEventV2({ data: [trackObj], balance, location, category: list_name }, 'select_item', 'bulletin');
    trackGTMEventV2({ data: [trackObj], balance, location, category: list_name }, 'view_item', 'bulletin');
  } else {
    trackGTMEventV2({ data: [trackObj], balance, category: list_name }, 'select_item', 'next-live-matches');
    trackGTMEventV2({ data: [trackObj], balance, category: list_name }, 'view_item', 'next-live-matches');
  }
};

export const trackViewItemListPopulerBetsPage = list => {
  const items = [];
  list?.list?.forEach((list, index) => {
    const listObject = {
      item_id: list.id.toString(),
      item_name: list[EVENT_FIELD_MAPPING.eventName],
      item_brand: 'iddaa',
      item_category: list[EVENT_FIELD_MAPPING.leagueName],
      item_list_name: 'Popüler Bahisler',
      item_list_id: 'Popüler Bahisler',
      index: index,
      item_category2: list?.htn,
      item_category3: list?.lgn,
      item_category4: '2', //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
      item_variant: GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]],
      price: list?.market?.val,
      quantity: 1,
      mbs: list?.market?.mbs,
      match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
      bet_type: list?.market?.n,
    };
    items.push(listObject);
  });
  trackGTMEventV2(items, 'view_item_list', 'populerBetsPage');
};

export const trackViewItemListPopulerBets = (list, balance) => {
  const items = [];
  list?.forEach((list, index) => {
    const listObject = {
      item_id: list.id.toString(),
      item_name: list[EVENT_FIELD_MAPPING.eventName],
      item_brand: 'iddaa',
      item_category: list[EVENT_FIELD_MAPPING.leagueName],
      item_list_name: 'Home Page - Popüler',
      item_list_id: 'Home Page - Popüler',
      index: index,
      item_category2: null,
      item_category3: null,
      item_category4: null, //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
      item_variant: GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]].toLowerCase(),
      price: list?.market?.val,
      quantity: 1,
      mbs: list?.market?.mbs,
      match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
      bet_type: list?.market?.n,
    };
    items.push(listObject);
  });


  //trackGTMEvent('view_item_list', { items });
  trackGTMEventV2({ items, balance }, 'view_item_list', 'populerBets');
};

export const trackSelectItemPopulerBets = (obj, balance) => {
  let trackObj = {
    item_id: obj.id.toString(),
    item_name: obj[EVENT_FIELD_MAPPING.eventName],
    item_brand: 'iddaa',
    item_category: obj[EVENT_FIELD_MAPPING.leagueName],
    item_list_name: 'Home Page - Popüler',
    item_list_id: 'Home Page - Popüler',
    item_category2: null,
    item_category3: null,
    item_category4: null,
    item_variant: GTA_SPORT_TYPE_NAMING[obj[EVENT_FIELD_MAPPING.sportType]].toLowerCase(),
    price: obj?.market?.val,
    quantity: 1,
    mbs: obj?.market?.mbs,
    match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    bet_type: obj?.market?.n,
  };
  trackGTMEventV2({ data: trackObj, balance }, 'select_item', 'populerBets');
  trackGTMEventV2({ data: trackObj, balance }, 'view_item', 'populerBets');
};

export const trackSelectItemPopulerBetsPage = (obj, balance) => {
  let trackObj = {
    item_id: obj.id.toString(),
    item_name: obj[EVENT_FIELD_MAPPING.eventName],
    item_brand: 'iddaa',
    item_category: obj[EVENT_FIELD_MAPPING.leagueName],
    item_list_name: 'Popüler Bahisler',
    item_list_id: 'Popüler Bahisler',
    item_category2: obj?.htn,
    item_category3: obj?.lgn,
    item_category4: '2', //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
    item_variant: GTA_SPORT_TYPE_NAMING[obj[EVENT_FIELD_MAPPING.sportType]],
    price: obj?.market?.val,
    quantity: 1,
    mbs: obj?.market?.mbs,
    match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    bet_type: obj?.market?.n,
  };
  trackGTMEventV2({ data: trackObj, balance }, 'select_item', 'populerBetsPage');
  trackGTMEventV2({ data: trackObj, balance }, 'view_item', 'populerBetsPage');
};

export const trackViewItemListTribun = list => {
  const items = [];
  list?.forEach((list, index) => {
    const listObject = {
      item_id: list.eventId.toString(),
      item_name: list.eventName,
      item_brand: 'iddaa',
      item_category: null, // gelen datada bu bilgi yok
      item_list_name: 'Tribün',
      item_list_id: 'Tribün',
      index: index,
      item_category2: null, // gelen datada bu bilgi yok
      item_category3: null, // gelen datada bu bilgi yok
      item_category4: null, // gelen datada bu bilgi yok
      item_variant: GTA_SPORT_TYPE_NAMING[list.sportType].toLowerCase(),
      price: list.odds,
      quantity: 1,
      mbs: list.mbs,
      match_time: null,
      bet_type: list.marketOutcomeName,
    };
    items.push(listObject);
  });

  trackGTMEventV2(items, 'view_item_list', 'tribun');
};

export const trackSelectItemTribun = (obj, balance) => {
  let trackObj = {
    item_id: obj.eventId.toString(),
    item_name: obj.eventName,
    item_brand: 'iddaa',
    item_category: null,
    item_list_name: 'Tribun',
    item_list_id: 'Tribun',
    item_category2: null,
    item_category3: null,
    item_category4: null, //Ligin önem sırasına göre numarası basılsın.örneğin en üst lig ise “1”, ikinci seviyede ise “2” olarak basılmalıdır.
    item_variant: GTA_SPORT_TYPE_NAMING[obj.sportType],
    price: obj.odds,
    quantity: 1,
    mbs: obj.mbs,
    match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    bet_type: obj.marketOutcomeName,
  };
  trackGTMEventV2({ data: trackObj, balance }, 'select_item', 'tribun');
  trackGTMEventV2({ data: trackObj, balance }, 'view_item', 'tribun');
};

export const trackViewItemListAuthors = (list, author) => {
  const items = [];
  list?.forEach((list, index) => {
    const listObject = {
      item_id: list.eventId.toString(),
      item_name: list.eventName,
      item_brand: 'iddaa',
      item_category: list.leagueName, // gelen datada bu bilgi yok
      item_list_name: `Yazarlar - ${author}`,
      item_list_id: `Yazarlar - ${author}`,
      index: index,
      item_category2: null, // gelen datada bu bilgi yok
      item_category3: null, // gelen datada bu bilgi yok
      item_category4: null, // gelen datada bu bilgi yok
      item_variant: matchTypeKeys[list.sportType],
      price: list?.marketResponse?.currentOddsWeb,
      quantity: 1,
      mbs: list.mbs,
      match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
      bet_type: list?.marketResponse?.label,
    };
    items.push(listObject);
  });


  trackGTMEventV2({ items, author }, 'view_item_list', 'authors');
};

export const trackSelectItemListAuthors = (list, author, balance) => {
  const items = [];
  const listObject = {
    item_id: list.eventId.toString(),
    item_name: list.eventName,
    item_brand: 'iddaa',
    item_category: list.leagueName, // gelen datada bu bilgi yok
    item_list_name: `Yazarlar - ${author}`,
    item_list_id: `Yazarlar - ${author}`,
    item_category2: null, // gelen datada bu bilgi yok
    item_category3: null, // gelen datada bu bilgi yok
    item_category4: null, // gelen datada bu bilgi yok
    item_variant: list.sportType,
    price: list?.marketResponse?.currentOddsWeb,
    quantity: 1,
    mbs: list.mbs,
    match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    bet_type: list?.marketResponse?.label,
  };
  items.push(listObject);

  trackGTMEventV2({ items, author, balance }, 'select_item', 'authors');
  trackGTMEventV2({ items, author, balance }, 'view_item', 'authors');
};

export const trackLiveStream = balance => (list, tabType) => {
  const type = tabType.tabType.split('-')[1];
  const list_name = type ? `Canlı izle - ${matchTypeTurkishKeys[type]}` : 'Canlı izle - Tümü';
  const items = [];
  list?.list?.forEach((list, index) => {
    const listObject = {
      item_id: list.sbsEventId.toString(),
      item_name: `${list.bilyonerHomeTeam} - ${list.bilyonerAwayTeam}`,
      item_brand: 'iddaa',
      item_category: list.tournamentName,
      item_list_name: list_name,
      item_list_id: list_name,
      index: index,
      item_category2: null, // gelen datada bu bilgi yok
      item_category3: null, // gelen datada bu bilgi yok
      item_category4: null, // gelen datada bu bilgi yok
      item_variant: matchTypeKeys[list.sportType],
      quantity: 1,
      mbs: null, //bu bilgi bu servisten gelmemektedir
      match_time: null, //bu bilgide gelmemekte
    };
    items.push(listObject);
  });
  trackGTMEventV2({ items, list_name, balance }, 'view_item_list', 'liveStreams');
};

export const trackSelectItemLiveStream = (obj, tabType, balance) => {
  const list_name = tabType ? `Canlı İzle - ${matchTypeTurkishKeys[tabType]}` : 'Canlı İzle - Tümü';
  const items = [];

  const listObject = {
    item_id: obj.sbsEventId.toString(),
    item_name: `${obj.bilyonerHomeTeam} - ${obj.bilyonerAwayTeam}`,
    item_brand: 'iddaa',
    item_category: obj.tournamentName,
    item_list_name: list_name,
    item_list_id: list_name,
    item_category2: null, // gelen datada bu bilgi yok
    item_category3: null, // gelen datada bu bilgi yok
    item_category4: null, // gelen datada bu bilgi yok
    item_variant: matchTypeKeys[obj.sportType],
    quantity: 1,
    mbs: null, //bu bilgi bu servisten gelmemektedir
    match_time: null, //bu bilgide gelmemekte
  };
  items.push(listObject);
  trackGTMEventV2({ items, list_name, balance }, 'select_item', 'liveStreams');
  trackGTMEventV2({ items, list_name, balance }, 'view_item', 'liveStreams');
};

export const trackViewItemListLiveMatches = (list, obj) => {
  const location = window.location.href.split('/');
  const isHomePage = location.length === 3;
  const category = isHomePage ? 'Home Page - Canlı' : SPORT_TYPE_UPPER_CASE[obj?.tabType];
  const list_name = location[3] === 'canli-iddaa' ? `Canlı - ${category}` : category;
  const items = [];

  list?.list?.forEach((list, index) => {
    const listObject = {
      item_id: list.id.toString(),
      item_name: list[EVENT_FIELD_MAPPING.eventName],
      item_brand: 'iddaa',
      item_category: list[EVENT_FIELD_MAPPING.leagueName],
      item_list_name: list_name,
      item_list_id: list_name,
      index: index,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_variant: GTA_SPORT_TYPE_NAMING[list[EVENT_FIELD_MAPPING.sportType]],
      price: list?.market?.val,
      quantity: 1,
      mbs: list?.mbs,
      match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
    };

    items.push(listObject);
  });
  trackGTMEventV2({ items, category: list_name }, 'view_item_list', 'liveMatchesWidget');
};

export const trackSelectItemLiveMatches = (obj, balance) => {
  //TODO BURAYI KONTROL ET buraya gelen datada bozukluk var
  const location = window.location.href.split('/');
  const isHomePage = location.length === 4;
  const category = isHomePage ? 'Home Page - Canlı' : SPORT_TYPE_UPPER_CASE[obj?.tabType];
  const list_name = location[3] === 'canli-iddaa' ? `Canlı - ${category}` : category;
  let trackObj = {
    item_id: obj.id.toString(),
    item_name: obj[EVENT_FIELD_MAPPING.eventName],
    item_brand: 'iddaa',
    item_category: obj[EVENT_FIELD_MAPPING.leagueName],
    item_list_name: list_name,
    item_list_id: list_name,
    item_category2: obj?.htn,
    item_category3: obj?.lgn,
    item_category4: null,
    item_variant: GTA_SPORT_TYPE_NAMING[obj[EVENT_FIELD_MAPPING.sportType]],
    quantity: 1,
    mbs: obj?.mbs,
    match_time: '0', // maç canlıysa “0”, yarınsa “1”, sonraki günlerde ise “2”, “3” .... şeklinde basılmalıdır.
  };
  trackGTMEventV2({ data: [trackObj], balance, category: list_name }, 'select_item', 'liveMatchesWidget');
  trackGTMEventV2({ data: [trackObj], balance, category: list_name }, 'view_item', 'liveMatchesWidget');
};

export const trackViewAuthorList = data => {
  const pathnames = window.location.pathname.split('/').filter(path => path !== '');
  const currentSubCategory = pathnames[1] ?? 'Tümü';


  const items = [];
  data?.forEach((item, index) => {
    const listObject = {
      item_id: item.id.toString(), // Yazar kodu
      item_name: `Yazar - ${item?.name}`, // Yazar-{Yazar Adı}
      item_brand: 'Yazar',
      item_list_id: `Yazarlar - ${currentSubCategory}`,
      item_list_name: `Yazarlar - ${currentSubCategory}`,
      item_variant: matchTypeKeys[item.sportType], // Yazdığı spor türü
      quantity: 1
    };
    items.push(listObject);
  });
  trackGTMEventV2(items, 'view_item_list', 'authorList');
};

export const trackSelectAuthorList = (data, balance) => {
  const items = [];
  const pathnames = window.location.pathname.split('/').filter(path => path !== '');
  const currentSubCategory = pathnames[1] ?? 'Tümü';

  const authorsObject = {
    item_id: data.id.toString(), // Yazar kodu
    item_name: `Yazar - ${data?.name}`, // Yazar-{Yazar Adı}
    item_brand: 'Yazar',
    item_list_id: `Yazarlar - ${currentSubCategory}`,
    item_list_name: `Yazarlar - ${currentSubCategory}`,
    item_variant: matchTypeKeys[data.sportType], // Yazdığı spor türü
    quantity: 1
  };
  items.push(authorsObject);

  trackGTMEventV2({ items, balance }, 'select_item', 'authorList');
  trackGTMEventV2({ items, balance }, 'view_item', 'authorList');

};

export const trackSTO = balance => {
  const item = [{
    item_id: 'ST12345',
    item_name: 'SporToto',
    item_brand: 'SporToto',
    item_list_id: 'SporToto',
    item_list_name: 'SporToto',
    quantity: 1
  }];
  trackGTMEventV2({ item, balance }, 'view_item', 'sportoto');
};

export const trackLogin = ({ login_type, user_id, user_balance }) => {
  // trackGTMEvent('login', {
  //   login_type: login_type,
  //   user_id: user_id
  // });
  //TODO userid hashlenmesi gerek semtr ekibiyle konusulcak
  trackGTMEventV2( { user_id, user_balance }, 'login', 'login');
};
export const trackSignUp = user_id => {
  //TODO userid hashlenmesi gerek semtr ekibiyle konusulcak
  trackGTMEventV2(user_id, 'sign_up', 'signUp');
};

export const trackLogout = () => {
  trackGTMEvent('logout', {});
};

export const trackBeginCheckoutError = error_type => {
  trackGTMEvent('begin_checkout_error', {
    error_type: error_type
  });
};

export const trackTribunFollowUser = () => {
  trackGTMEvent('tribune_follow_user', {});
};


export const trackSearch = search_term => {
  trackGTMEvent('search', {
    search_term: search_term
  });
};

export const trackEcommercePurchaseEP = ({ name, id }) => {
  trackGTMEvent('ecommerce_purchase_ep', {
    item_name: name,
    item_id: id,
    item_brand: 'Esya Piyangosu',
    item_category: 'Esya Piyangosu'
  });
};

export const trackEcommercePurchaseSk = ({ name, id }) => {
  trackGTMEvent('ecommerce_purchase_sk', {
    item_name: name,
    item_id: id,
    item_brand: 'Sans Karti',
    item_category: 'Sans Karti'
  });
};

export const trackShareTribunCoupon = () => {
  trackGTMEvent('tribun_coupon_share', {});
};

export const trackShare = () => {
  trackGTMEvent('share', {});
};

export const setUserAttributes = (keyValues, obj) => {
  if (typeof gtag === 'function' && 'object' && keyValues !== null) {
    gtag('set', 'user_properties', keyValues);
    updateGTMDimensions(keyValues, obj);
  }
};
